/* eslint-disable @typescript-eslint/no-explicit-any */
import { Textarea } from "@/components/ui/textarea";
type BulkEditProp = {
  value: string;
  placeholder?: string;
  manageList: any;
};
export const BulkEdit = ({ value, manageList, placeholder }: BulkEditProp) => {
  return (
    <Textarea
      placeholder={placeholder || "Pease add item"}
      value={value}
      autoFocus={true}
      onChange={(e) =>
        manageList({
          type: "bulk-edit-update",
          payload: { data: e.target.value },
        })
      }
      className="px-2 py-3 mt-2  h-auto max-h-[300px] min-h-[100px]  overflow-y-auto border relative border-slate-200 rounded-md"
    ></Textarea>
  );
};
